import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {getParam} from '../utils/utils';
import {formatText, truncate} from '../utils/utils';


import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewNarrative from "../components/ViewNarrative";
import ViewMetadata from "../components/ViewMetadata";

import FormConcept from "../components/FormConcept";
import FormLink from "../components/FormLink";

import RowKey from "../components/RowKey";

import SelectConceptModel from "../components/SelectConceptModel";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
////import ViewNarrativeVersion from "../components/ViewNarrativeVersion";
import ViewVersion from "../components/ViewVersion";
import {zipNarrative} from "../utils/utilsNarrative";

import { assetsNarrativeVersion } from "../utils/utilsNarrative";

import Rendition from '../components/Rendition';
import { Reply } from "react-bootstrap-icons";

import { getNarrative, getNarrativeVersion, addNarrative, editNarrative } from '../utils/utilsNarrative';
import { listLinks } from '../utils/utilsConceptModel';

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import Buffering from "../components/Buffering";

import { Check, CheckSquare } from 'react-bootstrap-icons';

import JSZip from "jszip";


class Narrative extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            renderState: 'loading',
            errorMessage: ''
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);

        this.handleExport = this.handleExport.bind(this);


        this.addLink = this.addLink.bind(this);
        this.removeLink = this.removeLink.bind(this);
        this.updateLink = this.updateLink.bind(this);

        this.addConcept = this.addConcept.bind(this);
        this.removeConcept = this.removeConcept.bind(this);
        this.updateConcept = this.updateConcept.bind(this);

        this.dsd = new dsd();

        this.FallBackNavigation = `/narratives`;


    }

    componentDidMount(){

       this.setup();

    }


    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadNarrative(id){

        if (id === undefined){
            return;
        }

        this.setState({
            renderState: 'loading'
        });

        getNarrative(
            this.dsd,
            id,
            (Narrative) => {
                // Update breadcrumb
                for (var i in window.Breadcrumb){
                    if (window.Breadcrumb[i][0] === 'narrative'){
                        window.Breadcrumb = window.Breadcrumb.slice(0,i);
                        break;
                    }
                }
                this.Breadcrumb = JSON.parse(JSON.stringify(window.Breadcrumb));
                window.Breadcrumb.push(['narrative',`/narrative/${id}`]);

                // Determine if user can edit
                let OfferEdit = false;
                if (this.dsd.loggedon && Narrative){
                    if (this.dsd.user.id == Narrative.idUser){
                        OfferEdit = true;
                    }
                }

                this.setState({
                    Narrative: Narrative,
                    FormData: Narrative,
                    OfferEdit: OfferEdit,
                    isLoaded: true,
                    renderState: 'loaded'
                });

                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsNarrative(Narrative._id);
                }

                this.fetchViz(id);

            },
            (error) => {
                this.setState({
                    renderState: 'failed',
                    errorMessage: 'Failed to load Narrative'
                });
            }
        );
        
        return;
        
    };


    async loadVersionAssets(id, idVersion){

        if (!id || !idVersion === null){
            return;
        }

        this.setState({ renderState: 'loading' });

        const assets = await assetsNarrativeVersion(this.dsd, id, idVersion);

        this.setState({
            mdVersionPage: assets["page.md"],
            VersionAssets: assets,
            isLoaded: true,
            renderState: 'loaded'
        });

        return;
        
    };


    fetchViz(id) {

       const onDoneDot = function(dot) {
           this.setState({ dot: dot });
       }.bind(this);

       const onFailDot = function(error) {
           console.error('Failed to fetch DOT:', error);
       }.bind(this);

       getNarrative(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

   };



    loadConceptModelLinks(idConceptModel){

        if (idConceptModel === undefined){
            return;
        }

        listLinks(
            this.dsd,
            {idConceptModel: idConceptModel},
            (links) => {
                this.setState(
                    {ConceptModelLinks: links},
                    () => {
                        this.GenerateLinks();
                    }
                );
            },
            (error) => {
                console.error('Failed to load concept model links:', error);
            }
        );
        
        return;
        
    };


    GenerateLinks(){

        let FormData = this.state.FormData;
        if (!('Links' in FormData)){
            FormData['Links'] = [];
        }
        let arrNew = Array.from(FormData.Links);


        for (let posL=0; posL < this.state.ConceptModelLinks.length; posL++){
            let Link = this.state.ConceptModelLinks[posL];

            let boolFound = false;
            for (let pos=0;pos<arrNew.length;pos++){
                let item = arrNew[pos];
                if (item.idLink == Link._id){
                    boolFound = true;
                }
            }
            if (!boolFound){
// check that both from and to concepts are in the Narrative

                let boolFoundFrom = false;
                let boolFoundTo = false;

                for (let posC=0;posC<FormData.Concepts.length;posC++){
                    if (FormData.Concepts[posC].idConcept == Link.idConceptFrom){
                        boolFoundFrom = true;
                    }
                    if (FormData.Concepts[posC].idConcept == Link.idConceptTo){
                        boolFoundTo = true;
                    }
                }
                if (boolFoundFrom && boolFoundTo){
                    arrNew.push({idLink:Link._id});
                }
            }
        }

        FormData.Links = arrNew;
        FormData.idLinkConceptModel = null;
        this.setState(
            {
                FormData: FormData
            }
        );

    }

    setup(){

        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            renderState: 'loading',
            errorMessage: '',

            OfferEdit: false,

            FormData: {},
            Controls: {
            },

            Narrative: null,

            vizNodeId: null,

            csv: null,

            idVersion: null,
            countVersions: null,

            dot: null

        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idNarrative = getParam('id', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);

        this.FallBackNavigation = `../narratives`;

        // If viewing a version, mark as loaded so version component displays
        if (StateChange.idVersion){
            StateChange.isLoaded = true;
            StateChange.renderState = 'loaded';
        }

        // For "new" mode, set isLoaded and renderState immediately
        if (StateChange.mode === 'new'){
            StateChange.isLoaded = true;
            StateChange.renderState = 'loaded';
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }


        this.setState(StateChange, async () => {

            // Load narrative data if in view/edit mode and idNarrative is available (and not viewing a version)
            if (this.state.mode !== 'new' && this.state.idNarrative && !this.state.idVersion){
                this.loadNarrative(this.state.idNarrative);
            }

            if (this.state.idVersion){
                await this.loadVersionAssets(this.state.idNarrative, this.state.idVersion);
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsNarrativeVersions(this.state.idNarrative);
                }
            }

        });
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':
                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                        this.props.navigation(`/narrative/${this.state.idNarrative}`);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false
                })
        
                switch (this.state.mode){
                    case 'new':
                        addNarrative(
                            this.dsd,
                            this.state.FormData,
                            (idNarrative) => {
                                this.props.navigation(`/narrative/${idNarrative}`);
                            },
                            (error) => {
                                this.setState({ isFailed: true });
                            }
                        );
                        break;
                    case 'edit':
                        editNarrative(
                            this.dsd,
                            this.state.idNarrative,
                            this.state.FormData,
                            () => {
                                this.props.navigation(`/narrative/${this.state.idNarrative}`);
                            },
                            (error) => {
                                this.setState({ isFailed: true });
                            }
                        );
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        switch (event.target.name){
            case 'btnGenerateLinks':
                this.loadConceptModelLinks(this.state.FormData.idLinkConceptModel);
                break;
        }

        event.preventDefault();
    };

    handleAddVersion(event) {

        this.setState({newVersion:true});

    }


    addConcept(){
        let FormData = {...this.state.FormData};
        FormData.Concepts = [...(FormData.Concepts || []), {}];
        
        this.setState({"FormData": FormData});
    }

    removeConcept(seq){

       let FormData = {...this.state.FormData};
       FormData.Concepts = [...(FormData.Concepts || [])];
       FormData.Concepts.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }

    updateConcept(seq, Concept){

       let FormData = {...this.state.FormData};
       FormData.Concepts = [...(FormData.Concepts || [])];
       FormData.Concepts[seq-1] = Concept;

       this.setState({"FormData": FormData});

    }


    addLink(){
        let FormData = {...this.state.FormData};
        FormData.Links = [...(FormData.Links || []), {}];
  
        this.setState({"FormData": FormData});
    }

    removeLink(seq){

       let FormData = {...this.state.FormData};
       FormData.Links = [...(FormData.Links || [])];
       FormData.Links.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }


    updateLink(seq, Link){

       let FormData = {...this.state.FormData};
       FormData.Links = [...(FormData.Links || [])];
       FormData.Links[seq-1] = Link;
        
       this.setState({"FormData": FormData});

    }


    addKey(){
        let FormData = {...this.state.FormData};
        FormData.Keys = [...(FormData.Keys || []), {}];
  
        this.setState({"FormData": FormData});
    }

    removeKey(seq){

       let FormData = {...this.state.FormData};
       FormData.Keys = [...(FormData.Keys || [])];
       FormData.Keys.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }


    updateKey(seq, Key){

       let FormData = {...this.state.FormData};
       FormData.Keys = [...(FormData.Keys || [])];
       FormData.Keys[seq-1] = Key;

       this.setState({"FormData": FormData});


    }



    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;

        let target = null;
        if (event.target.tagName == "a"){
            target = event.target;
        } else{
            if ("parentElement" in event.target){
                if (event.target.parentElement.tagName == "a"){
                    target = event.target.parentElement;
                }
            }
        }

        if (target){
            if ("href" in target){
                idNode = target.href.baseVal;
                StateChange.vizNodeId = idNode;
            }
        }
        

        if (!idNode){
            return;
        }
        
        let partsVizNodeId = idNode.split('_');
        switch(partsVizNodeId[0]){
            case 'concept':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/concept/${partsVizNodeId[1]}`);
                }
                break;
            case 'entity':
                if (partsVizNodeId.length > 3){
                    switch(partsVizNodeId[2]){
                        case 'structure':
                            this.props.navigation(`/structure/${partsVizNodeId[3]}`);
                            break;
                    }
                }else{
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/entity/${partsVizNodeId[1]}`);
                    }
                }
                break;
            case 'structure':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                }
                break;
        }

        this.setState(StateChange);

        event.preventDefault();

    };

    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.Narrative){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idNarrative} type='narrative' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idNarrative}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
        this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }

    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let idNarrative = this.state.idNarrative;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipNarrative(this.dsd, idNarrative, idVersion);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `narrative_${idNarrative}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }

    }


    visualise(){
    
        if (!this.state.Narrative){
            return <Buffering/>;
        }



        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.state.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        // Handle renderState for loading, failed, or denied states
        switch (this.state.renderState) {
            case 'loading':
                return <Buffering />;
            case 'failed':
                return <PD.ErrorBox>Error: {this.state.errorMessage}</PD.ErrorBox>;
            case 'denied':
                return <PD.ErrorBox>Access Denied</PD.ErrorBox>;
            default:
                break;
        }

        if (this.state.isUpdated){
            switch (this.state.mode){
                case 'remove':
                    this.props.navigation(this.FallBackNavigation);
                    return null;
                default:
                    break;
            };
        };

        if (this.state.isLoaded) {

            if (this.state.idVersion){
//                return(
//                    <ViewNarrativeVersion idVersion={this.state.idVersion} idNarrative={this.state.idNarrative}/>
//                )

                return(
                    <div>
                        <PD.Button onClick={ () => this.props.navigation(`/narrative/${this.state.idNarrative}`) } value="back"><Reply/></PD.Button>
                        <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                            {this.state.isExporting && <Buffering/>}
                        </PD.Button>
                        <ViewVersion mdPage={this.state.mdVersionPage} assets={this.state.VersionAssets} idVersion={this.state.idVersion}/>
                    </div>
                )

            }
            
            switch (this.state.mode){
                case 'new':
                case 'edit':

                    return (
                    <div>

                        <PD.Heading>{this.state.mode} Narrative</PD.Heading>
    
                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }
    
                        <form> 
                            <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                            <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>
                            <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>
                            
                            {this.FormKeys()}
                            {this.FormConcepts()}
                            {this.FormLinks()}

                            <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                {
                                    this.dsd.config.ComponentStatuses.map(
                                        (status, posStatus) => 
                                            {
                                                return(
                                                    <option key={posStatus} value={status}>{status}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                        </form>
    
                    </div>    
                    );
                case 'remove':
                    return (
                        <div>
                            <PD.Heading>{this.state.mode} Narrative</PD.Heading>

                            {this.state.isFailed &&
                                <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                            }

                            <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                            <ViewNarrative json={this.state.Narrative}/>
                        </div>
                    )
                case 'view':
                default:

                    if (!this.state.Narrative){
                        return <div/>
                    }
                    
//                    const countItems = this.state.countItems == null ? "Loading..." : this.state.countItems;

                    let countConcepts = 0;
                    let countLinks = 0;
                    let countKeys = 0;

                    if (this.state.Narrative.Concepts){
                        countConcepts = this.state.Narrative.Concepts.length;
                    }
                    if (this.state.Narrative.Links){
                        countLinks = this.state.Narrative.Links.length;
                    }
                    if (this.state.Narrative.Keys){
                        countKeys = this.state.Narrative.Keys.length;
                    }

                    return (
                        <div>
                            <div>
                                <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                <PD.Heading>Narrative:{this.state.Narrative.name}</PD.Heading>
                            </div>

                            {this.state.OfferEdit &&
                                <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                </span>
                            }

                            <ViewNarrative Narrative={this.state.Narrative}/>

                            <br/>

                            <PD.Tabs>

                                <div label='Visualise'>
                                    {this.visualise()}
                                </div>

                                <div label={`Keys(${countKeys})`}>

                                    {isArray(this.state.Narrative.Keys) &&
                                        <PD.Table className="list">
                                            <PD.Thead>
                                                <PD.Tr>
                                                    <PD.Th>Legend</PD.Th>
                                                    <PD.Th>Color</PD.Th>
                                                </PD.Tr>
                                            </PD.Thead>

                                            <PD.Tbody>
                                                {
                                                    this.state.Narrative.Keys.map(
                                                        (Key, pos) => 
                                                        {
                                                            return (
                                                                <PD.Tr key={pos}>
                                                                    <PD.Td>
                                                                        {Key.legend}
                                                                    </PD.Td>
                                                                    <PD.Td>
                                                                        {Key.color}
                                                                    </PD.Td>
                                                               </PD.Tr>

                                                            )
                                                        }
                                                    )
                                                }
                                            </PD.Tbody>
                                        </PD.Table>
                                    }
                                </div>

                                <div label={`Concepts(${countConcepts})`}>

                                    {isArray(this.state.Narrative.Concepts) &&
                                        <PD.Table className="list">
                                            <PD.Thead>
                                                <PD.Tr>
                                                    <PD.Th>Name</PD.Th>
                                                    <PD.Th>Concept Model</PD.Th>
                                                    <PD.Th>Description</PD.Th>
                                                    <PD.Th>Key</PD.Th>
                                                </PD.Tr>
                                            </PD.Thead>

                                            <PD.Tbody>
                                                {
                                                    this.state.Narrative.Concepts.map(
                                                        (NarrativeConcept, pos) => 
                                                        {

                                                            if (NarrativeConcept.Concept){

                                                                let Key = null;
                                                                if (this.state.Narrative.Keys){
                                                                    if (NarrativeConcept.seqKey){
                                                                        if (NarrativeConcept.seqKey <= this.state.Narrative.Keys.length){
                                                                            Key = this.state.Narrative.Keys[NarrativeConcept.seqKey-1]
                                                                        }
                                                                    }
                                                                }                                                                                                        

                                                                return (
                                                                    <PD.Tr key={pos}>
                                                                        <PD.Td>
                                                                            <PD.PdNavLink to={"/concept/" + NarrativeConcept.Concept._id} > {NarrativeConcept.Concept.name}</PD.PdNavLink>
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            {(() => {
                                                                                if (NarrativeConcept.Concept.ConceptModel){
                                                                                    return NarrativeConcept.Concept.ConceptModel.name;
                                                                                }
                                                                                return null;
                                                                            })()}
                                                                    </PD.Td>
                                                                        
                                                                        <PD.Td>
                                                                            {formatText(truncate(NarrativeConcept.Concept.description, 400))}
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            {Key != null &&
                                                                                Key.legend
                                                                                }
                                                                        </PD.Td>


                                                                    </PD.Tr>

                                                                )
                                                            }
                                                            return null;
                                                        }
                                                    )
                                                }
                                            </PD.Tbody>
                                        </PD.Table>
                                    }

                                </div>


                                <div label={`Links(${countLinks})`}>

                                    {isArray(this.state.Narrative.Links) &&
                                        <PD.Table className="list">
                                            <PD.Thead>
                                                <PD.Tr>
                                                    <PD.Th>Name</PD.Th>
                                                    <PD.Th>Concept Model</PD.Th>
                                                    <PD.Th>Description</PD.Th>
                                                    <PD.Th>Inverse?</PD.Th>
                                                </PD.Tr>
                                            </PD.Thead>

                                            <PD.Tbody>
                                                {
                                                    this.state.Narrative.Links.map(
                                                        (NarrativeLink, pos) => 
                                                        {

                                                            if (NarrativeLink.Link){

                                                                return (
                                                                    <PD.Tr key={pos}>
                                                                        <PD.Td>
                                                                            <PD.PdNavLink to={"/link/" + NarrativeLink.Link._id} > {NarrativeLink.Link.name}</PD.PdNavLink>
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            {(() => {
                                                                                if (NarrativeLink.Link.ConceptModel){
                                                                                    return NarrativeLink.Link.ConceptModel.name;
                                                                                }
                                                                                return null;
                                                                            })()}
                                                                        </PD.Td>
                                                                        
                                                                        <PD.Td>
                                                                            {formatText(truncate(NarrativeLink.Link.description, 400))}
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            {NarrativeLink.inverse &&
                                                                                <CheckSquare/>
                                                                            }
                                                                        </PD.Td>

                                                                    </PD.Tr>

                                                                )
                                                            }
                                                            return null;
                                                        }
                                                    )
                                                }
                                            </PD.Tbody>
                                        </PD.Table>
                                    }

                                </div>

                                <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                    {this.versions()}
                                </div>

                                <div label='Developer'>
                                    <Rendition
                                        endpoint="/narratives"
                                        id={this.state.idNarrative}
                                    />
                                </div>



                                <div label='Metadata'>
                                    <ViewMetadata Data={this.state.Narrative} />
                                </div>


                            </PD.Tabs>


                        </div>
                    )
            };
        };

        return <div />;
    };


    FormConcepts(){

        let seqNext = 1;
        if (this.state.FormData.Concepts){
            seqNext = this.state.FormData.Concepts.length + 1;
        }
        return (
            <fieldset>
                <legend>Concepts</legend>
                {this.state.FormData.Concepts &&
                    this.state.FormData.Concepts.map(
                        (Concept, posConcept) => 
                        {
                            let seq = posConcept+1;
                            return(
                                this.FormConcept('edit', seq, Concept)
                            )
                        }
                    )
                }
                {this.FormConcept('new', seqNext)}
            </fieldset>
        );

    }

    FormConcept(mode, seq, Concept = {}){
        return(
            <div>
                <FormConcept 
                    key={seq.toString()} 
                    mode={mode}
                    onAdd={this.addConcept}
                    onRemove={this.removeConcept}
                    onUpdate={this.updateConcept}
                    Concept={Concept} 
                    Keys={this.state.FormData.Keys} 
                    seq={seq}
                />
            </div>
        )
    }



    FormLinks(){

        
        let seqNext = 1;
        if (this.state.FormData.Links){
            seqNext = this.state.FormData.Links.length + 1;
        }
        return (
            <fieldset>
                <legend>Links</legend>

{// offer - generate from concept model
}
                <form>
                    <SelectConceptModel label='Generate links from Concept Model' name="idLinkConceptModel" value={this.state.FormData.idLinkConceptModel} onChange={this.handleChange}/>
                    {this.state.FormData.idLinkConceptModel &&
                        <PD.Button type="submit" onClick={this.handleButton} name="btnGenerateLinks"value="Generate" />    
                    }
                </form>

                {this.state.FormData.Links &&
                    this.state.FormData.Links.map(
                        (Link, posLink) => 
                        {
                            let seq = posLink+1;
                            return(
                                this.FormLink('edit', seq, Link)
                            )
                        }
                    )
                }
                {this.FormLink('new', seqNext)}

            </fieldset>
        );

    }

    FormLink(mode, seq, Link = {}){
        return(
            <div>
                <FormLink 
                    key={seq.toString()} 
                    mode={mode} 
                    onAdd={this.addLink}
                    onRemove={this.removeLink}
                    onUpdate={this.updateLink}
                    Link={Link} 
                    seq={seq} 
                />
            </div>
        )
    }


    FormKeys(){

        let seqNext = 1;
        if (this.state.FormData.Keys){
            seqNext = this.state.FormData.Keys.length + 1;
        }
        return (
            <div>
                <PD.Heading level="2">Keys</PD.Heading>

                <PD.Table type="list">
                    {this.state.FormData.Keys &&
                        this.state.FormData.Keys.map(
                            (Key, posKey) => 
                            {
                                let seq = posKey+1;
                                return(
                                    this.FormKey('edit', seq, Key)
                                )
                            }
                        )
                    }
                    {this.FormKey('new', seqNext)}
                </PD.Table>

            </div>
        );

    }

    FormKey(mode, seq, Key = {}){
        return(
            <RowKey mode={mode} parent={this} Key={Key} seq={seq} Narrative={this.state.Narrative}/>
        )
    }

};



// Wrap and export
export default function Narrative_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Narrative {...props} navigation={navigation} location={location} params={params} />;
  }
